import type { ClientError } from "./http.ts";
import type { Hub } from "./hub.ts";

type Said =
  | { readonly kind: "segurando"; readonly text: string; readonly undo: () => void }
  | { readonly kind: "registrada"; readonly text?: string; readonly open?: { readonly label: string; readonly href: string } }
  | { readonly kind: "falhou"; readonly error: ClientError; readonly retry?: () => void }
  | { readonly kind: "conectado" };
export type Notice = Said & { readonly id: number };

const undoableMs = 7000;

export function createNotices(hub: Hub) {
  let current: Notice | undefined;
  let said = 0;
  const show = (notice: Notice | undefined) => {
    current = notice;
    hub.touch("notices");
    return notice?.id;
  };
  const say = (notice: Said) => show({ ...notice, id: ++said });
  const dismiss = (id: number) => (current?.id === id ? show(undefined) : undefined);
  return {
    say,
    undoable(text: string, undo: () => void, after: (ms: number, run: () => void) => void): void {
      const taken = () => {
        dismiss(shown ?? 0);
        undo();
      };
      const shown = say({ kind: "segurando", text, undo: taken });
      after(undoableMs, () => dismiss(shown ?? 0));
    },
    notice: () => current,
    dismiss,
    forget: () => show(undefined),
  };
}
